module.exports = __webpack_public_path__ + "static/media/LandingPageLogo4.fe15887a.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/LandingPageLogo4.png
// module id = 2566
// module chunks = 0